export default __webpack_public_path__ + "static/media/Group8559.c0ba32c6.svg";